import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Box } from 'rebass/styled-components'
import ReactPlayer from 'react-player'
import MediaRender from './MediaRender'
import styled from 'styled-components'

const CoverImage = styled(Box)`
    cursor: pointer;
    &:before,
    &:after {
        content: '';
        display: block;
        position: absolute;
        will-change: transform;
    }

    &:before {
        background-color: ${(props) => props.theme.colors.white};
        border-radius: 100%;
        color: ${(props) => props.theme.colors.aquaLight};
        height: 58px;
        left: calc(50% - 29px);
        opacity: 0.8;
        top: calc(50% - 29px);
        width: 58px;
        z-index: 1;
    }
    &:after {
        border-color: transparent transparent transparent ${(props) => props.theme.colors.aquaDark};
        border-style: solid;
        border-width: 27px 0 27px 44px;
        box-sizing: border-box;
        height: 44px;
        left: calc(50% - 22px);
        margin-left: 4px;
        margin-top: -6px;
        top: calc(50% - 22px);
        transform: scale(0.5);
        transform-origin: 50% 50%;
        width: 44px;
        z-index: 1;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        &:before {
            transform: scale(0.8);
        }
        &:after {
            transform: scale(0.4);
        }
    }
`

const VideoRender = ({ file, options }) => {
    const [config, setConfig] = useState({ player: {}, url: {}, target: '', imageCover: true })

    useEffect(() => {
        let configObj = {}
        let url = {}
        let target = ''
        switch (file.media_type) {
        case 'video':
            const baseUrl = process.env.GATSBY_CLOUDINARY_VIDEO_URL
            const transform = 'q_auto,f_auto/' // https://cloudinary.com/blog/image_optimization_for_websites_beautiful_pages_that_load_quickly
            const filepath = file.filepath + file.public_id
            const ending = transform + filepath

            if (options && options.backgroundVideo) {
                configObj = {
                    muted: options.muted || true,
                    playing: options.autoplay || true,
                    loop: options.loop || true,
                    playsinline: options.inline || true,
                }
            } else {
                configObj = {
                    muted: (options && options.muted) || false,
                    playing: (options && options.autoplay) || false,
                    loop: (options && options.loop) || false,
                    playsinline: (options && options.inline) || false,
                    controls: (options && options.controls) || true,
                }
            }
            url = baseUrl + ending + '.mp4'
            target = 'video'
            break
        case 'video/youtube':
        case 'video/vimeo':
            if (options && options.backgroundVideo) {
                configObj = {
                    muted: options.muted || true,
                    playing: options.autoplay || true,
                    loop: options.loop || true,
                    playsinline: options.inline || true,
                }
            } else {
                let boolean = null
                if (options && options.autoplay === true) {
                    boolean = true
                } else {
                    boolean = false
                }
                configObj = {
                    muted: (options && options.muted) || boolean,
                    playing: (options && options.autoplay) || false,
                    loop: (options && options.loop) || false,
                    playsinline: (options && options.inline) || false,
                    controls: (options && options.controls) || true,
                }
            }
            url = file.filepath
            target = 'iframe'
            break
        default:
        }
        setConfig({ player: configObj, url, target, imageCover: true })
    }, [file])

    const playVideo = () => {
        const update = { ...config }
        update.player = { ...config.player, playing: true }
        update.imageCover = false
        setConfig(update)
    }

    return (
        <Box
            sx={{
                backgroundColor: 'white',
                height: 0,
                overflow: 'hidden',
                // paddingBottom: (900 / 16) + '%',
                paddingBottom: '56.25%',
                position: 'relative',
                [`& ${config.target}`]: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    border: 0,
                },
                width: '100%',
            }}>
            {
                (config.imageCover && options && options.coverImage) ?
                    <CoverImage onClick={() => playVideo()} sx={{
                        bottom: 0,
                        border: 0,
                        height: '100%',
                        left: 0,
                        position: 'absolute',
                        top: 0,
                        width: '100%',
                        zIndex: 1,
                    }}>
                        <MediaRender file={options.coverImage} options={{ backgroundImage: true }} />
                    </CoverImage> :
                    ( options.autoplay ) ?
                        <Box sx={{
                            pointerEvents: 'none',
                        }}>
                            <ReactPlayer width="100%" height="100%" {...config.player} url={config.url} />
                        </Box> :
                        <ReactPlayer width="100%" height="100%" {...config.player} url={config.url} />
            }
        </Box>
    )
}

function mapStateToProps(state) {
    return {}
}

export default connect(mapStateToProps)(VideoRender)
